import type { TFunction } from 'i18next'
import { z } from 'zod'

import type { TrpcReactUtilsClient } from '@mntn-dev/app-common'
import {
  EmailAddressSchema,
  NameSchema,
  OptionalNonEmptyStringSchema,
  TagsByCategoryMapSchema,
  TeamProfileDomainUpsertModelSchema,
} from '@mntn-dev/domain-types'
import { UpdateTeamWithProfileInputSchema } from '@mntn-dev/team-service/client'
import { nonEmptyArraySchema } from '@mntn-dev/utilities'
import type { ZodInfer } from '@mntn-dev/utility-types'

import { UniqueTeamNameSchemaBuilder } from './public.schema.ts'

export const EditTeamProfileFormModelSchema =
  UpdateTeamWithProfileInputSchema.extend({
    profile: TeamProfileDomainUpsertModelSchema.extend({
      emailAddresses: nonEmptyArraySchema(EmailAddressSchema).optional(),
    }),
    tags: TagsByCategoryMapSchema,
  })

export type EditTeamProfileFormModel = ZodInfer<
  typeof EditTeamProfileFormModelSchema
>

export const getEditTeamProfileFormValidationSchema = (
  tValidation: TFunction<'validation'>,
  trpcClient: TrpcReactUtilsClient,
  fieldLabel: string,
  ignoreName?: string
) => {
  return UpdateTeamWithProfileInputSchema.extend({
    name: UniqueTeamNameSchemaBuilder({
      t: tValidation,
      trpcClient: trpcClient,
      field: fieldLabel,
      ignoreName: ignoreName,
    }),
    tags: TagsByCategoryMapSchema,
  })
}

export const EditTeamProfileExampleDetailsFormModelSchema = z.object({
  title: NameSchema,
  description: OptionalNonEmptyStringSchema(),
  tags: TagsByCategoryMapSchema.optional(),
})

export type EditTeamProfileExampleDetailsFormModel = ZodInfer<
  typeof EditTeamProfileExampleDetailsFormModelSchema
>
